import videojs from "video.js";
import videoJs from "video.js";
const BTN_LIST = {
  0: "",
  1: "qform_widget-btn-blue",
  2: "qform_widget-btn-green",
  3: "qform_widget-btn-black",
  4: "qform_widget-btn-white"
};
const WIDGET_IN_BODY_VALUE = 1;

/**
 * @class VideoWidget *
 * @param {Element} selector - The DOM element selector where the widget will be initialized.
 * @param {SettingsWidget} settings - The settings object for configuring the video widget.
 * */
export class VideoWidget {
  /**
   * Constructs a new instance of the widget.
   * @constructor
   * @param {Element} selector - The DOM element selector where the widget will be initialized.
   * @param {SettingsWidget} settings - The settings object for configuring the video widget.
   */
  constructor(selector, settings) {
    this.id = settings.id;
    this.mode = true;
    /**
     * @type SettingsWidget
     * */
    this.settings = settings;
    this.root = selector;
    this.device = settings.options.device;
    this.stylePreview = settings.type_display; // 1 - inHTML | 2 - vertical| 3 - circle
    this.widgetOrientation = settings.orientation_video; //1 - vertical | 2 - horizontal (for inHTML style oly)
    this.styleBtn = settings.color_button || 0; // 0 - `default`(black) | 1 - btn-green | 2 - btn-blue | 3 - btn-grad
    this.useDesign = settings.use_css;
    this.playerType = settings.player_type; // 1 - fullScreen mod | 2 - in widget

    this.listeners = [];
    this.startTime = settings.options.startTimeGlob; // Время начала работы скрипта
    this.emitterWidgets = settings.options.emitterWidgets;
    this.emitterFormWidget = settings.options.emitterFormWidget;
    this.widgetId = settings.id;
    this.widgetIndex = settings.widgetIndex;
    this.siteId = Number(settings.site_id);
    this.statId = String(settings.uuid_stat);
    this.isRunWidget = false;
    this.endInitTime = null;
    this.buildTime = null;
    //сворачивался ли виджет хотя бы раз после рендеринга
    this.isExpandedOnceWidget = false;
    //нажималась ли кнопка CTA хотя бы раз
    this.isCtaClickedOnce = false;
    //запрет на отправку статистики по отстройке
    this.avoidStatistics = false;
    this.avoidPlay = false;
    //хранить данные о показе виджета в рамках сессии (только для виджетов в углу экрана)
    this.sessionLifecycle = settings.show_one === 1;
    this.mainVideo = settings.mainVideo;
    this.playOnHover = settings.hover_play;
    this.previewVideoUrl = settings.preview;
    this.mainVideoResolution = settings.resolution;
    this.isIOSDevice = settings.options.isIOSDevice;
    this.isMacOSDevice = settings.options.isMacOSDevice;
    this.isIPadOSDevice = settings.options.isIPadOsDevice;
    this.isModernSafariBrowser = settings.options.isModernSafariBrowser;
    this.videoWidth = null;
    this.videoHeight = null;
    //настройки для формы в виджете
    this.formData = settings.form;
    this.idBtnList = [];
    this.ctaDelay = settings.sec_cta || 0;
    this.ctaButtonAppearanceTimeout = null; //переменная для хранения таймера отсрочки появления кнопки действия виджета

    this._setBtnCTA();
    this.videoId = `${this.widgetId}-${this.widgetIndex}_main-video`;
    this.sourceId = `${this.widgetId}-${this.widgetIndex}_source`;
    this.previewId = `${this.widgetId}-${this.widgetIndex}_preview-video`;
    this.videoBoxId = `${this.widgetId}-${this.widgetIndex}_video-box`;
    this.previewSourceId = `${this.widgetId}-${this.widgetIndex}_preview-source`;
    this.widgetMenuBoxId = `${this.widgetId}-${this.widgetIndex}_menu-box`;
    this.widgetQformLabelBoxId = `${this.widgetId}-${this.widgetIndex}qform-label-box`;
    this.widgetQformLabelId = `${this.widgetId}-${this.widgetIndex}qform-label`;
    this.widgetBoxId = `${this.widgetId}-${this.widgetIndex}_box`;
    this.widgetVideoWrapId = `${this.widgetId}-${this.widgetIndex}_wrap`;
    this.widgetBoxDurationId = `${this.widgetId}-${this.widgetIndex}_duration`;
    this.widgetBtnMuteId = `${this.widgetId}-${this.widgetIndex}_btn_mute`;
    this.widgetBtnRestartId = `${this.widgetId}-${this.widgetIndex}_btn_restart`;
    this.widgetTimelineId = `${this.widgetId}-${this.widgetIndex}_timeline`;
    this.widgetTimelineContainerId = `${this.widgetId}-${this.widgetIndex}_timeline-container`;
    this.widgetTimelineTimeId = `${this.widgetId}-${this.widgetIndex}_timeline-time`;
    this.widgetTimelineMarkerId = `${this.widgetId}-${this.widgetIndex}_timeline-marker`;
    this.widgetTimelinePointtimeId = `${this.widgetId}-${this.widgetIndex}_timeline-pointtime`;
    this.widgetBtnViewBoxControlsId = `${this.widgetId}-${this.widgetIndex}_btn_view-box_controls`;
    this.widgetBtnViewBoxRestartId = `${this.widgetId}-${this.widgetIndex}_btn_view-box_restart`;
    this.widgetBtnViewBoxCloseId = `${this.widgetId}-${this.widgetIndex}_btn_view-box-close`;
    this.widgetBtnViewBoxPlayId = `${this.widgetId}-${this.widgetIndex}_btn_view-box_play`;
    this.widgetTopBtnBoxId = `${this.widgetId}-${this.widgetIndex}_top-btn-box`;
    this.widgetTopControlsBoxId = `${this.widgetId}-${this.widgetIndex}_top-control-box`;
    this.widgetTopBtnCloseId = `${this.widgetId}-${this.widgetIndex}_top-btn-close`;
    this.widgetTopBtnCollapseId = `${this.widgetId}-${this.widgetIndex}_top-btn-collapse`;
    this.widgetTopBtnMuteId = `${this.widgetId}-${this.widgetIndex}_top-btn-mute`;
    this.widgetTopBtnLoaderId = `${this.widgetId}-${this.widgetIndex}_loader`;
    this.widgetVideoPreloaderId = `${this.widgetId}-${this.widgetIndex}_preloader`;
    this.widgetTopBtnViewsBoxId = `${this.widgetId}-${this.widgetIndex}_views-box`;
    this.widgetTopBtnVideoId = `${this.widgetId}-${this.widgetIndex}_video`;
    this.widgetFormWrapperId = `${this.widgetId}-${this.widgetIndex}_form-wrapper`;
    this.widgetFormSecondWrapperId = `${this.widgetId}-${this.widgetIndex}_form-second-wrapper`;
    this.widgetFormBoxId = `${this.widgetId}-${this.widgetIndex}_form-box`;
    this.expandedWidget = false;
    this.soundIsActive = false;
    this.lagCounter = 0;
    this.isPreviewLoaded = !this.previewVideoUrl;
    this.lastFrameTime = null;
    this.showLogo = this.settings.show_logo;
    this.showTimeline = this.settings.show_timeline;
    this.isTimelineDragging = false;
    this.isVideoStoppedBeforeRewind = false;
    //флаг, показывающий, что форма была уже отстроена
    this.isFormAlreadyInit = false;
    // this.formDisplayType = settings.form_display_type;
    //флаг, отвечающий за отображение формы в оверлее (в случае, если хотя бы один шаг формы содержит более 3 полей)
    // this.showFormInOverlay = this.formData?.overlay;
    this.showFormInOverlay = settings.form_display_type === 0 || this.formData?.overlay;
    //флаг об успешной отправке формы в виджете
    this.formWasSent = false;
    //показана ли форма в виджете в данный момент
    this.isFormShown = false;
    this.isAdaptive = settings.is_adaptive; // new field
    this.useVwCss = settings.use_vw_css; // new field
    this.preview = settings.preview; // new field
    this.previewImg = settings.preview_img; // new field
    // this.userPreviewImg = settings.user_preview_img  // new field
    this.loadBy = settings.load_by; // new field

    this.captionLink = settings.captionLink ?? "https://ru.qform.io";
  }
  init() {
    //контейнер виджета (не основной)
    this.$widgetBox = this.$root.$el.querySelector(`#${this.widgetBoxId}`);
    //кнопка перезапуска видео в видеоплеере
    this.$widgetBtnRestart = this.$root.$el.querySelector(`#${this.widgetBtnRestartId}`);
    //кнопка сворачивания видеоплеера
    this.$widgetBtnClose = this.$root.$el.querySelector(`#${this.widgetBtnViewBoxCloseId}`);
    //контейнер для кнопок в центре виджета
    this.$widgetViewBoxControls = this.$root.$el.querySelector(`#${this.widgetBtnViewBoxControlsId}`);
    //кнопка проигрывания видео в центре виджета
    this.$widgetViewBoxPlay = this.$root.$el.querySelector(`#${this.widgetBtnViewBoxPlayId}`);
    //кнопка перезапуска видео в центре виджета
    this.$widgetViewBoxRestart = this.$root.$el.querySelector(`#${this.widgetBtnViewBoxRestartId}`);
    //навбар с кнопками в виджете с классом "expanded"
    this.$widgetTopBtnBox = this.$root.$el.querySelector(`#${this.widgetTopBtnBoxId}`);
    //навбар с кнопками управления воспроизведением в развернутом виджете "в теле страницы"
    this.$widgetTopControlsBox = this.$root.$el.querySelector(`#${this.widgetTopControlsBoxId}`);
    //блок с длительностью видео в видеоплеере
    this.$widgetBoxDuration = this.$root.$el.querySelector(`#${this.widgetBoxDurationId}`);
    // кнопка закрытия
    this.$widgetTopBtnClose = this.$root.$el.querySelector(`#${this.widgetTopBtnCloseId}`);
    // кнопка сворачивания виджета
    this.$widgetTopBtnCollapse = this.$root.$el.querySelector(`#${this.widgetTopBtnCollapseId}`);
    //кнопка переключения звука видео
    this.$widgetTopBtnMute = this.$root.$el.querySelector(`#${this.widgetTopBtnMuteId}`);
    //кнопка перекючения звука в видеоплеере
    this.$widgetBtnMute = this.$root.$el.querySelector(`#${this.widgetBtnMuteId}`);
    // this.$widgetTopBtnLoader = this.$root.$el.querySelector(`#${this.widgetTopBtnLoaderId}`);
    //контейнер, содержащий в себе контейнеры с кнопками в центре виджета и контейнером с видео
    this.$widgetTopBtnViewsBox = this.$root.$el.querySelector(`#${this.widgetTopBtnViewsBoxId}`);
    //контейнер с кнопками меню виджета
    this.$widgetMenuBox = this.$root.$el.querySelector(`#${this.widgetMenuBoxId}`);
    //обертка над всем содержимым виджета
    this.$widgetVideoWrap = this.$root.$el.querySelector(`#${this.widgetVideoWrapId}`);
    //блок прелоадера для видео
    this.$widgetVideoPreloader = this.$root.$el.querySelector(`#${this.widgetVideoPreloaderId}`);
    //блок лейбла Qform (в развернутом виде)
    this.$widgetQformLabelBox = this.$root.$el.querySelector(`#${this.widgetQformLabelBoxId}`);
    //ссылка в лейбле Qform (в развернутом виде)
    this.$widgetQformLabel = this.$root.$el.querySelector(`#${this.widgetQformLabelId}`);
    //таймлайн
    this.$widgetTimeline = this.$root.$el.querySelector(`#${this.widgetTimelineId}`);
    //контейнер таймлайна и времени
    this.$widgetTimelineContainer = this.$root.$el.querySelector(`#${this.widgetTimelineContainerId}`);
    //блок с временем видео для таймлайна
    this.$widgetTimelineTime = this.$root.$el.querySelector(`#${this.widgetTimelineTimeId}`);
    //перемещающийся маркер на таймлайне
    this.$widgetTimelineMarker = this.$root.$el.querySelector(`#${this.widgetTimelineMarkerId}`);
    //данные по времени видео над перемещающимся маркер на таймлайне
    this.$widgetTimelinePointtime = this.$root.$el.querySelector(`#${this.widgetTimelinePointtimeId}`);
    //основной контейнер для формы в виджете
    this.$widgetFormWrapper = this.$root.$el.querySelector(`#${this.widgetFormWrapperId}`);
    //основной контейнер для формы в виджете
    this.$widgetFormSecondWrapper = this.$root.$el.querySelector(`#${this.widgetFormSecondWrapperId}`);
    //контейнер для формы в виджете
    this.$widgetFormBox = this.$root.$el.querySelector(`#${this.widgetFormBoxId}`);
    //кнопка скрытия оверлея формы
    this.$widgetFormWrapperCloseBtn = this.$root.$el.querySelector(`#${this.widgetFormCloseBtnId}`);
    //кнопка показа формы при отображении формы "по кнопке"
    this.$showFormButton = null;
    this.elVideo = this.$root.$el.querySelector(`#${this.videoId}`) || null;
    this.elSource = this.$root.$el.querySelector(`#${this.sourceId}`) || null;
    this.elPreview = this.$root.$el.querySelector(`#${this.previewId}`) || null;
    this.elSourcePreview = this.$root.$el.querySelector(`#${this.previewSourceId}`) || null;
    this.elVideoBox = this.$root.$el.querySelector(`#${this.videoBoxId}`) || null;
    if (videoJs.getPlayer(this.videoId)) {
      videoJs.getPlayer(this.videoId).dispose();
    }
    this.player = videojs(this.videoId, {
      options: {
        navigationUI: "hide"
      },
      html5: {
        nativeControlsForTouch: false
      }
    });
    this.player.src([{
      src: this.mainVideo,
      type: "application/x-mpegURL"
    }]);
    this.player.autoplay(false);
    this.player.el_.insertAdjacentElement("beforebegin", this.elVideo);
    this.player.el_.remove();

    //обсервер нужен для отклчения нативных элементов управления в Mozill Firefox
    let observer = new MutationObserver(mutationRecords => {
      if (mutationRecords[0].attributeName === "controls") {
        mutationRecords[0].target.controls = false;
      }
    });
    observer.observe(this.elVideo, {
      attributes: true
    });

    //добавляем кастомные классу для элемента VIDEO
    this.elVideo.classList.add("views-box_content_video", "qform-has-preview");
    window.players[this.id] = this.player;
    this.listeners = [
    //динамическое событие для поддержки работы виджета в старых сафари
    {
      eventName: "click",
      method: "onToggleModeWidget",
      el: this.$widgetBox
    }, {
      eventName: "click",
      method: "onCloseWidget",
      el: this.$widgetTopBtnClose
    }, {
      eventName: "click",
      method: "onCollapseWidget",
      el: this.$widgetTopBtnCollapse
    }, {
      eventName: "click",
      method: "onSetPageWidget",
      el: this.$widgetMenuBox
    }, {
      eventName: "loadeddata",
      method: "onSetPageWidget",
      el: this.$widgetMenuBox
    }, {
      eventName: "click",
      method: "onMuteCurrentVideo",
      el: this.$widgetTopBtnMute
    }, {
      eventName: "click",
      method: "onMuteCurrentVideo",
      el: this.$widgetBtnMute
    }, {
      eventName: "click",
      method: "onRestartCurrentVideo",
      el: this.$widgetBtnRestart
    }, {
      eventName: "click",
      method: "onRestartCurrentVideo",
      el: this.$widgetViewBoxRestart
    }, {
      eventName: "click",
      method: "playVideo",
      el: this.$widgetViewBoxPlay
    }];
    if (this.formData && this.showFormInOverlay) {
      this.listeners.push({
        eventName: "click",
        method: "onClickCloseFormOverlay",
        el: this.$widgetFormWrapperCloseBtn
      });
    }
    if (!this.showLogo && this.showTimeline) {
      this.listeners.push({
        eventName: "input",
        method: "onTimelineInput",
        el: this.$widgetTimeline
      });
      this.listeners.push({
        eventName: "change",
        method: "onTimelineChange",
        el: this.$widgetTimeline
      });
      this.listeners.push({
        eventName: "mouseenter",
        method: "onTimelineMouseenter",
        el: this.$widgetTimeline
      });
      this.listeners.push({
        eventName: "mousemove",
        method: "onTimelineMousemove",
        el: this.$widgetTimeline
      });
      this.listeners.push({
        eventName: "mouseleave",
        method: "onTimelineMouseleave",
        el: this.$widgetTimeline
      });
    }

    //добавляем обработчик сворачивания проигрывателя для мобильных устройств
    if (this.$widgetBtnClose) {
      this.listeners.push({
        eventName: "click",
        method: "onCloseViewBox",
        el: this.$widgetBtnClose
      });
    }
    //если выбрано воспроизведение при наведении виджета "в теле страницы"
    if (this.stylePreview === 1 && this.playOnHover && this.previewVideoUrl && !this.expandedWidget) {
      this.listeners.push({
        eventName: "mouseenter",
        method: "playPreview",
        el: this.$widgetBox
      });
      this.listeners.push({
        eventName: "mouseleave",
        method: "stopPreview",
        el: this.$widgetBox
      });
    }
    this.listeners.push({
      eventName: "touchstart",
      method: "onVideoTouchStart",
      el: this.elVideo
    });
    this.listeners.push({
      eventName: "touchend",
      method: "onVideoTouchEnd",
      el: this.elVideo
    });
    if (this.elPreview) {
      this.listeners.push({
        eventName: "loadeddata",
        method: "onLoadedDataPreview",
        el: this.elPreview
      });
    }
    this.loopCurrentVideo();

    // this.player.on('loadedmetadata', this.getResolutionFromVideofile.bind(this))

    this.player.on("loadeddata", this.onVideoLoadedData);
    this.player.on("timeupdate", this.onVideoTimeupdate);
    this.player.on("pointerdown", this.onToggleModeWidget);
    this.player.on("progress", this.onVideoProgress);
    this.setVideoSizeOptions();
    this.reachYmTarget("qform_video_init");
    this.endInitTime = new Date().getTime();
    this.fullTime = this.endInitTime - this.startTime;
    this.hoverPlay = this.settings.hover_play;
    this.setVideoViewInLocalStorage(false);
    this.initListener();
    if (!this.avoidStatistics) {
      this.updateStatistics();
    }
  }
  async loadModule() {
    try {
      this.$ = await import(/* webpackChunkName: "dom" */"../core/dom").then(data => {
        return data.$;
      });
      this.$root = this.$(this.root);
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * Вернём значение CTA
   *
   * @param actionType
   * @returns {null|*}
   * @private
   *
   * 1 - Переход по ссылке
   * 2 - Скролл до блока
   * 3 - Форма внутри виджета
   */
  _getCTAValue(actionType) {
    let ctaValue = null;
    if (actionType === 1) {
      ctaValue = this.settings.link_cta;
    } else if (actionType === 2) {
      ctaValue = this.settings.scroll_cta;
    } else if (actionType === 3) {
      ctaValue = this.settings.form_cta;
    }
    return ctaValue;
  }

  /**
   * Сгенерим старый объект menu
   * @private
   */
  _setBtnCTA() {
    try {
      const valueCTA = this._getCTAValue(this.settings.event_cta);
      if (this.settings.use_cta && valueCTA) {
        this.settings.menu = [];
        this.settings.menu.push({
          id: "idbtn" + this.settings.event_cta,
          name: this.settings.text_button_cta,
          actionType: this.settings.event_cta,
          actionValue: valueCTA
        });
      }
      this.idBtnList.push(`${this.widgetId}-${this.widgetIndex}_btn-0`);
    } catch (err) {
      throw err;
    }
  }
  getHtml() {
    return `
    <div
      class="qform-widget ${this.stylePreview === 3 ? "circle" : ""} ${this.stylePreview === 1 ? "integrated" : ""} ${BTN_LIST[this.styleBtn]} ${this.useVwCss ? "" : "disable-styles"} ${this.hoverPlay !== 0 ? "play-icon" : ""}
      "
      id="${this.widgetBoxId}"
    >
      <div class="qform-widget_wrap" id="${this.widgetVideoWrapId}">
        <div class="controls-top" id="${this.widgetTopControlsBoxId}">
          <div class="controls-top_left">
            <span class="qform_btn-mute qform-widget__player-btn" id="${this.widgetBtnMuteId}"><i class="icon-mute sound-on"></i></span>
            ${this.device === "mobile" ? `<span class="restart qform-widget__player-btn" id="${this.widgetBtnRestartId}"><i class="icon-restart"></i></span>` : ""}
          </div>
            ${this.device === "mobile" ? `<span class="qform_widget-time" id="${this.widgetBoxDurationId}">0:00</span>` : ""}
          <div class="controls-top_right">
            ${this.device !== "mobile" ? `<span class="restart qform-widget__player-btn" id="${this.widgetBtnRestartId}"><i class="icon-restart"></i></span>` : ""}
            ${this.device !== "mobile" ? `<span class="qform_widget-time" id="${this.widgetBoxDurationId}">0:00</span>` : ""}
            ${this.device === "mobile" ? `<span class="close qform-widget__player-btn" id="${this.widgetBtnViewBoxCloseId}"><i class="icon-close"></i></span>` : ""}
          </div>
        </div>
        <div class="actions qform_close" id="${this.widgetTopBtnBoxId}">
          <div class="controls-top_left-wrapper">
          <button class="qform_btn-mute" id="${this.widgetTopBtnMuteId}">
            <i class="icon-mute sound-on"></i>
          </button>
          </div>
          <div class="controls-top_right-wrapper">
            <button class="qform_btn-collapse" id="${this.widgetTopBtnCollapseId}"></button>
            <button class="qform_btn-close" id="${this.widgetTopBtnCloseId}"></button>
          </div>
        </div>
        <div class="loader" id="${this.widgetTopBtnLoaderId}"></div>
        <div class="views-box" id="${this.widgetTopBtnViewsBoxId}">

          <div class="views-box_controls" id="${this.widgetBtnViewBoxControlsId}">
            <div class="play" id="${this.widgetBtnViewBoxPlayId}">
              <i class="icon-play"></i>
            </div>
            <div class="restart" id="${this.widgetBtnViewBoxRestartId}">
              <i class="icon-restart"></i>
            </div>
          </div>
          ${this.getTabs()}
        </div>
        <div class="menu ${this.showTimeline && !this.showLogo ? "qform__above-timeline" : ""}" id="${this.widgetMenuBoxId}">
          ${this.getMenu()}
        </div>
        ${this.formData ? `<div class="qform-widget__form-wrapper" id="${this.widgetFormWrapperId}">
              <div class="qform-widget__form-wrapper-box" id="${this.widgetFormSecondWrapperId}">
                <div class="qform-widget__form-box" id="${this.widgetFormBoxId}"></div>
                <div class="qform-widget__form-wrapper__btn-box">
                  <button class="qform-widget__form-wrapper__close-btn" id="${this.widgetFormCloseBtnId}"></button>
                </div>
              </div>
            </div>` : ""}
        ${this.showLogo ? `<div class="label-qform" id="${this.widgetQformLabelBoxId}">
                <a href="${this.getLink()}" target="_blank" id="${this.widgetQformLabelId}"
                >видеовиджет QForm.io</a>
              </div>` : ""}
        ${!this.showLogo && this.showTimeline ? `<div class="qform-widget__timeline-wrapper">
            <span class="qform-widget__timeline-time" id="${this.widgetTimelineTimeId}"></span>
            <div class="qform-widget__timeline-container" id="${this.widgetTimelineContainerId}">
              <i class="qform-widget__timeline-marker qform-hidden" id="${this.widgetTimelineMarkerId}">
                <div class="qform-widget__timeline-pointtime__box">
                  <span class="qform-widget__timeline-pointtime" id="${this.widgetTimelinePointtimeId}">0:00/0:00</span>
                </div>
              </i>
              <input class="qform-widget__timeline-input" id="${this.widgetTimelineId}" type="range" step="1" value="0" min="0">
            </div>
          </div>` : ""}
      </div>
    </div>
    `;
  }
  getTabs() {
    return `
      <div class="views-box_tab active">
        <div class="status" id="${this.videoBoxId + "_status"}"></div>
        <div class="views-box_content" id="${this.videoBoxId}">
          <!-- preview -->
          <video
            class="views-box_content_video_qform-preview"
            loop
            muted
            id="${this.previewId}"
            playsinline
            preload="auto"
            poster="${this.previewImg}"
            ${this.isIOSDevice || this.isIPadOSDevice ? `src="${this.previewVideoUrl}"` : ""}
          >
            <source id="${this.previewSourceId}" src="${this.previewVideoUrl}" type="video/mp4">
          </video>
          <!-- loader -->
          <div class="qform__video-preloader" id="${this.widgetVideoPreloaderId}">
            <div class="qform__video-preloader-img"></div>
          </div>
        <!-- stream -->
        <video
            id="${this.videoId}"
            class="views-box_content_video"
            preload="none"
            poster="${this.previewImg}"
            autoplay
            muted
            playsinline
          >
           ${this.isIOSDevice || this.isIPadOSDevice ? `
              <source src="${this.mainVideo}" type="application/x-mpegURL">
            ` : ""}
          </video>
        </div>
      </div>
      `;
  }
  getMenu() {
    const menuElement = document.createElement("div");

    this.settings?.menu?.forEach((menuItem, idx) => {
      const menuItemElement = document.createElement("button");
      menuItemElement.classList.toggle("menu_btn", this.useDesign);
      menuItemElement.id = this.idBtnList[idx];
      menuItemElement.setAttribute("data-id_in_menu", `${this.settings?.menu[idx].id}`);
      menuItemElement.innerHTML = `${this.settings?.menu[idx].name}`;
      menuElement.appendChild(menuItemElement);
    });

    return menuElement.innerHTML;
  }
  getRoot() {
    this.$widgetMainBox = this.$.create("div", "wrapper");
    this.$widgetMainBox.html(this.getHtml());

    //добавляем дата-аттрибуты для функционирования сворачивания виджетов "круглый" и "вертикальный" по миссклику
    if (this.stylePreview !== 1) {
      this.addDataAttrs(this.$widgetMainBox.$el, "clickid");
      this.addWidgetMissClickListener();
    }
    return this.$widgetMainBox;
  }

  /*  🤬🤬🤬🤬🤬🤬🤬🤬🤬🤬🤬🤬 */
  getLink() {
    switch (this.settings.country_id) {
      // Казахстан
      case 115:
        return "https://kz.qform.io/?utm_source=site_partner&utm_medium=video_link&utm_campaign=video_users";
      // Армени
      case 14:
        return `https://am-${this.settings.lang_tag}.qform.io/video/?utm_source=backlinks&utm_medium=video&region=am&lang=${this.settings.lang_tag}`;
      // Nigeria
      case 160:
        return "https://ng-en.qform.io/video/?utm_source=backlinks&utm_medium=video&region=ng&lang=en";
      // Египет
      case 66:
        return "https://eg-en.qform.io/video/?utm_source=backlinks&utm_medium=video&region=eg&lang=en";
      // Индия
      case 102:
        return "https://in-en.qform.io/video/?utm_source=backlinks&utm_medium=video&region=in&lang=en";
      // Индонезия
      case 103:
        return "https://id-en.qform.io/video/?utm_source=backlinks&utm_medium=video&region=id&lang=en";
      // ОАЭ
      case 234:
        return "https://ae-en.qform.io/video/?utm_source=backlinks&utm_medium=video&region=ae&lang=en";
      // Russia:
      case 1:
        return "https://ru.qform.io/?utm_source=site_partner&utm_medium=video_link&utm_campaign=video_users";
      default:
        return "https://qform.io/?utm_source=site_partner&utm_medium=video_link&utm_campaign=video_users";
    }
  }

  /**
   * добавление дата аттрибутов для элемента и всех его потомков
   * @param {Element} $el - элемент, надо которым необходимо выполнить манипуляции
   * @param {String} attrName - имя для дата-аттрибута
   * @returns void
   */
  addDataAttrs($el, attrName) {
    $el.setAttribute(`data-${attrName}`, this.widgetId);
    if ($el.children.length) {
      for (let i = 0; i < $el.children.length; i++) {
        $el.children[i].setAttribute(`data-${attrName}`, this.widgetId);
        this.addDataAttrs($el.children[i], attrName);
      }
    }
  }
  addWidgetMissClickListener() {
    document.addEventListener("click", e => {
      this.onWidgetMissClick(e);
    }, {
      capture: true
    });
  }
  onWidgetMissClick(event) {
    if (!this.$widgetMainBox.$el.contains(event.target) && this.expandedWidget && !event.target.closest(".qform-teleports-modal") && !event.target.closest("#baguetteBox-overlay")) {
      this.collapseExpandedWidget();
    }
  }
  initListener() {
    this.listeners.forEach(listener => {
      if (!this[listener.method]) {
        const nameComponent = this.name || "(не известен)";
        throw new Error(`QForm: "Не найден метод ${listener.method} в компоненте ${nameComponent}"`);
      }
      this[listener.method] = this[listener.method].bind(this);
      this.$root.on(listener.eventName, this[listener.method], listener.el);
    });
  }
  removeListener() {
    this.listeners.forEach(listener => {
      this.$root.off(listener.eventName, this[listener.method], listener.el);
    });
  }
  onVideoTouchStart(event) {
    this.touchStartCoords = {
      x: event.targetTouches[0].pageX,
      y: event.targetTouches[0].pageY
    };
  }
  onVideoTouchEnd(event) {
    this.touchEndCoords = {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
    this.widgetSwipeAction(this.detectSwipeDirection(this.touchStartCoords, this.touchEndCoords));
  }
  detectSwipeDirection(swipeStartCoords, swipeEndCoords) {
    const deltaX = swipeEndCoords.x - swipeStartCoords.x;
    const deltaY = swipeEndCoords.y - swipeStartCoords.y;
    if (Math.abs(deltaX) < Math.abs(deltaY)) {
      return deltaY > 0 ? "down" : "up";
    }
  }
  widgetSwipeAction(direction) {
    if (direction === "down") {
      this.collapseExpandedWidget();
    }
  }
  onVideoProgress = () => {
    if (this.expandedWidget) {
      this.lagCounter++;
      if (this.lagCounter > 10 && !this.player.paused() && this.isPreviewLoaded) {
        this.toggleVideoPreloader("show");
      }
    }
  };
  onVideoLoadedData = event => {
    if (event && event.target) {
      if (this.videoId === event.target.id) {
        this.duration = event.target.duration;
      }
      this.$widgetBoxDuration.innerHTML = this.getFormatRemainingTimeDisplay(this.player.remainingTimeDisplay());
      if (!this.showLogo && this.showTimeline) {
        this.$widgetTimeline.setAttribute("max", this.player.duration());
      }
    }
  };

  /**
   * @param {Number} seconds
   * @returns {"hh:mm:ss" || "mm:ss"}
   * */
  getFormatRemainingTimeDisplay(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const remainingSeconds = seconds % 60;
    if (hours > 0) {
      return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${remainingSeconds.toFixed().toString().padStart(2, "0")}`;
    } else {
      return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toFixed().toString().padStart(2, "0")}`;
    }
  }
  onVideoTimeupdate = () => {
    if (this.isPreviewLoaded) {
      this.toggleVideoPreloader("hide");
      this.lagCounter = 0;
    }
    if (!this.showLogo && this.showTimeline) {
      this.$widgetTimeline.value = this.player.currentTime();
      this.setTimelineProgress();
    }

    //если видео зациклено
    if (this.player?.loop()) {
      //если текущее время меньше, чем время предыдущего кадра, то видео началось заново
      if (this.lastFrameTime > this.player.currentTime()) {
        if (this.expandedWidget) {
          this.reachYmTarget("qform_video_view");
          if (!this.checkVideoFullViewed()) {
            this.setVideoViewInLocalStorage(true);
            this.updateStatistics({
              fullView: true
            });
          }
          this.reachYmTarget("qform_video_reload");
        }
      }
      //запоминаем точку на таймлайне, на которой располагался последний кадр
      this.lastFrameTime = this.player.currentTime();
    }
    //если видео не закончено
    if (!this.player.ended()) {
      this.$widgetBoxDuration.innerHTML = this.getFormatRemainingTimeDisplay(this.player.remainingTimeDisplay());
      if (!this.showLogo && this.showTimeline) {
        this.$widgetTimelineTime.innerHTML = `${this.getFormatRemainingTimeDisplay(this.player.currentTime())}/${this.getFormatRemainingTimeDisplay(this.player.duration())}`;
      }
      //если видео закончилось
    } else {
      this.$widgetBoxDuration.innerHTML = this.getFormatRemainingTimeDisplay(this.player.remainingTimeDisplay());
      if (!this.showLogo && this.showTimeline) {
        this.$widgetTimelineTime.innerHTML = this.getFormatRemainingTimeDisplay(this.player.duration());
      }
      this.$widgetViewBoxControls.classList.add("restart");
      if (this.expandedWidget) {
        this.reachYmTarget("qform_video_view");
        if (!this.checkVideoFullViewed()) {
          this.setVideoViewInLocalStorage(true);
          this.updateStatistics({
            fullView: true
          });
        }
      }
    }
  };
  onTimelineInput($event) {
    if (!this.isTimelineDragging) {
      this.isTimelineDragging = true;
      if (this.player.paused()) {
        //запоминаем, было ли остановлено видео перед началом перемотки
        this.isVideoStoppedBeforeRewind = true;
      }
    }

    //превентивно убираем кнопку рестарта
    this.$widgetViewBoxControls.classList.remove("restart");
    this.pauseVideo();
    this.setTimelineProgress();
    this.player.currentTime($event.target.value);
  }
  onTimelineChange($event) {
    this.isTimelineDragging = false;
    this.player.currentTime($event.target.value);
    if (!this.isVideoStoppedBeforeRewind) {
      //не запускаем видео, если оно было остановлено перед перемоткой
      this.playVideo();
    } else {
      this.isVideoStoppedBeforeRewind = false;
    }
  }
  onTimelineMouseenter() {
    this.$widgetTimelineMarker.classList.remove("qform-hidden");
    this.$widgetTimelineTime.classList.add("qform-hidden");
  }
  onTimelineMousemove($event) {
    $event.stopPropagation();
    this.$widgetTimelineMarker.style.left = `${$event.offsetX}px`;
    const timeOnMarker = $event.offsetX / this.$widgetTimeline.offsetWidth * this.player.duration();
    this.$widgetTimelinePointtime.innerHTML = `${this.getFormatRemainingTimeDisplay(timeOnMarker)}/${this.getFormatRemainingTimeDisplay(this.player.duration())}`;
  }
  onTimelineMouseleave() {
    this.$widgetTimelineMarker.classList.add("qform-hidden");
    this.$widgetTimelineTime.classList.remove("qform-hidden");
  }
  setTimelineProgress() {
    const min = this.$widgetTimeline.min;
    const max = this.$widgetTimeline.max;
    const val = this.$widgetTimeline.value;
    this.$widgetTimeline.style.backgroundSize = (val - min) * 100 / (max - min) + "% 100%";
  }

  // getResolutionFromVideofile(event) {
  //   if (event && event.target && !this.videoWidth && !this.videoHeight) {
  //     this.videoWidth = +event.target.videoWidth;
  //     this.videoHeight = +event.target.videoHeight;
  //   }
  // }

  onLoadedDataPreview() {
    this.toggleVideoPreloader("hide");
    this.isPreviewLoaded = true;
    this.toggleOnHoverPlayIcon();
  }
  onMuteCurrentVideo(event) {
    event?.stopPropagation();
    const muteIcon = event.target;
    //меняем изображение на иконке отключения звука
    if (muteIcon.className.includes("sound-on")) {
      muteIcon.classList.remove("sound-on");
      muteIcon.classList.add("sound-off");
      this.mutedButton = event.target;
    } else if (muteIcon.className.includes("sound-off")) {
      muteIcon.classList.remove("sound-off");
      muteIcon.classList.add("sound-on");
      this.mutedButton = null;
    }
    this.muteVideo(!this.soundIsActive);
  }
  onRestartCurrentVideo(event) {
    event?.stopPropagation();
    this.player.currentTime(0);
    this.playVideo();
    this.$widgetViewBoxControls.classList.remove("restart");
    //если событие рестарта произошло при нажатии на кнопку
    if (event) {
      this.reachYmTarget("qform_video_reload");
    }
  }
  showPreview() {
    //показываем превью
    this.elPreview.style.display = "block";
    this.elPreview.currentTime = 0;
  }
  hidePreview() {
    this.elPreview.style.display = "none";
  }
  toggleVideoPreloader(action) {
    this.$widgetVideoPreloader.classList[`${action === "hide" ? "add" : "remove"}`]("qform-preloader-hidden");
  }
  onSetPageWidget(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.target.dataset.id_in_menu) {
      this.settings?.menu.forEach(btn => {
        if (btn.id === event.target.dataset.id_in_menu) {
          this.hideMenu();
          switch (btn.actionType) {
            case 1:
              this.collapseExpandedWidget();
              window.open(btn.actionValue, `${+this.settings.newTab === 0 ? "_self" : "_blank"}`);
              break;
            case 2:
              this.collapseExpandedWidget();
              this.scrollToBlock(btn.actionValue);
              break;
            case 3:
              this.setWidgetForm().then();
              break;
          }
          if (!this.isCtaClickedOnce) {
            this.isCtaClickedOnce = true;
            this.updateStatistics();
          }
          this.reachYmTarget("qform_video_cta_click");
        }
      });
    }
  }
  onCloseWidget(event) {
    event.preventDefault();
    event.stopPropagation();
    this.closeWidget();
    this.reachYmTarget("qform_video_close");
  }
  onCloseViewBox(event) {
    event.preventDefault();
    event.stopPropagation();
    this.collapseExpandedWidget();
  }
  closeWidget() {
    let {
      forcedClose = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (this.isRunWidget) {
      this.expandedWidget = false;
      this.isRunWidget = false;
      this.$root.$el.classList.add("qform__closed-widget");
      this.$root.clear();
      if (this.sessionLifecycle && !forcedClose) {
        sessionStorage.setItem(this.id, "closed");
      }
    }
  }
  onCollapseWidget(event) {
    event.preventDefault();
    event.stopPropagation();
    this.collapseExpandedWidget();
  }

  //функция установки оригинального размера видео для режима отображения "в теле" в развернутом виде
  setVideoOriginalSize(controlHeight) {
    if (this.videoHeight <= controlHeight && this.device !== "mobile") {
      this.$widgetVideoWrap.style.width = this.videoWidth + "px";
      this.$widgetVideoWrap.style.height = this.videoHeight + "px";
    }
  }
  setVideoSizeOptions() {
    if (this.mainVideoResolution && /\d{3,4}x\d{3,4}/.test(this.mainVideoResolution)) {
      this.videoWidth = +this.mainVideoResolution.split("x")[0];
      this.videoHeight = +this.mainVideoResolution.split("x")[1];
    }
  }
  setVideoSize() {
    //если видео горизонтальное
    //5/4 - минимальное вертикальное соотношение сторон видео для определения, что видео - горизонтальное
    const aspectRatio = this.videoWidth / this.videoHeight;
    if (aspectRatio >= 5 / 4) {
      this.$widgetVideoWrap.classList.add("qform-horizontal-video");
      this.setVideoOriginalSize(720);
      //если видео вертикальное
    } else if (aspectRatio <= 4 / 5) {
      this.$widgetVideoWrap.classList.add("qform-vertical-video");
      this.setVideoOriginalSize(830);
      //если видео квадратное
    } else if (aspectRatio < 5 / 4 && aspectRatio > 4 / 5) {
      this.$widgetVideoWrap.classList.add("qform-square-video");
      this.setVideoOriginalSize(720);
    }
    this.$root.$el.style.width = this.$widgetBox.clientWidth + "px";
  }
  onToggleModeWidget = event => {
    event.preventDefault();
    event.stopPropagation();
    if (this.playerType === 2) {
      if (this.previewVideoUrl) {
        this.hidePreview();
      }
      // this.showMenu()

      this.onRestartCurrentVideo();
      this.toggleVideoPreloader("show");
      if (!this.isExpandedOnceWidget) {
        this.isExpandedOnceWidget = true;
        this.updateStatistics();
      }
      if (this.showLogo && !this.showTimeline) {
        this.applyForceLabelStyles();
      }
      return;
    }
    if (!this.expandedWidget) {
      if (this.previewVideoUrl) {
        this.hidePreview();
      }
      //если виджет располагается в теле страницы, форматируем видео для режима увеличения
      if (this.stylePreview === 1) {
        this.setVideoSize();
      }
      this.$widgetBox.classList.add("expanded");
      // document.body.append(this.$widgetBox)
      // Вынос видеовиджета в body
      if (this.stylePreview === 1) {
        document.body.append(this.$widgetBox);
      }
      if (this.stylePreview !== 1) {
        this.$widgetTopBtnBox.classList.add("qform-collapse");
        this.$widgetTopBtnBox.classList.add("qform-mute");
      }
      //показываем кнопку действия через установленное время
      if (this.settings.use_cta) {
        if (!this.isExpandedOnceWidget) {
          this.ctaButtonAppearanceTimeout = setTimeout(() => {
            this.showMenu();
            clearTimeout(this.ctaButtonAppearanceTimeout);
            //если виджет в теле страницы (this.stylePreview == 1), то при раскрытии показываем кнопку сразу
          }, this.ctaDelay * 1000);
        } else {
          //если виджет без формы
          if (!this.formData) {
            this.showMenu();
            //если виджет с формой
          } else {
            //если виджет показывается сразу по CTA
            if (!this.showFormInOverlay) {
              if (!this.formWasSent && this.isFormAlreadyInit) {
                this.toggleFormVisibility("show").then();
              } else {
                if (!this.formWasSent) {
                  this.showMenu();
                }
              }
              //если виджет отображается по нажатии на собственную кнопку
            } else {
              if (!this.formWasSent) {
                this.showMenu();
              }
            }
          }
        }
      }
      this.muteVideo(false);
      this.loopCurrentVideo(this.stylePreview !== WIDGET_IN_BODY_VALUE);
      this.onRestartCurrentVideo();
      this.toggleVideoPreloader("show");
      this.reachYmTarget("qform_video_expand");
      this.expandedWidget = true;
      if (this.stylePreview === 1 && this.formData && this.showFormInOverlay) {
        this.$widgetFormSecondWrapper.style.height = this.$widgetVideoWrap.clientHeight + "px";
      }
      if (!this.isExpandedOnceWidget) {
        this.isExpandedOnceWidget = true;
        this.updateStatistics();
      }
      if (this.showLogo && !this.showTimeline) {
        this.applyForceLabelStyles();
      }
    } else {
      //для виджета "в теле страницы"
      if (this.widgetBoxId === event.target.id) {
        this.hideMenu();
        this.collapseExpandedWidget();
        if (this.stylePreview === 1) {
          this.$root.$el.style.removeProperty("width");
        }
        //для остальных типов виджетов
      } else {
        if (event.target.tagName === "VIDEO") {
          if (this.player.paused()) {
            this.playVideo();
          } else {
            this.pauseVideo();
          }
        }
      }
    }

    // }
  };
  collapseExpandedWidget() {
    this.player.currentTime(0);
    this.pauseVideo();
    this.toggleFormVisibility("hidden").then();
    this.expandedWidget = false;
    this.$widgetBox.classList.remove("expanded");
    if (this.stylePreview === 1) {
      document.querySelector(`[data-widget=${this.id}][data-index-widget="${this.widgetIndex}"] .wrapper`).append(this.$widgetBox);
    }
    this.reachYmTarget("qform_video_collapse");
    if (this.$widgetQformLabelBox) {
      this.$widgetQformLabelBox.style.display = "none";
    }
    if (this.stylePreview !== 1) {
      this.$widgetTopBtnBox.classList.remove("qform-collapse");
      this.$widgetTopBtnBox.classList.remove("qform-mute");
      this.$widgetMenuBox.classList.remove("menu-shown");
    } else {
      this.$widgetVideoWrap.style = "";
    }

    //показываем превью
    if (this.previewVideoUrl) {
      this.showPreview();
    }

    //если сворачивают виджет с выключенным звуком, то меняем класс кнопки звука
    if (this.mutedButton) {
      this.mutedButton.classList.remove("sound-off");
      this.mutedButton.classList.add("sound-on");
    }
    clearTimeout(this.ctaButtonAppearanceTimeout);
    this.muteVideo();
    this.lastFrameTime = null;
  }
  hideMenu() {
    this.$widgetMenuBox.classList.remove("menu-shown");
    this.$widgetMenuBox.classList.add("hide");
  }
  showMenu() {
    this.$widgetMenuBox.classList.remove("hide");
    this.$widgetMenuBox.classList.add("menu-shown");
  }
  toggleCtaBtnVisibility() {
    let action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "show";
    const ctaBtn = document.getElementById(this.idBtnList[0]);
    ctaBtn.classList[action === "show" ? "remove" : "add"]("qform-hidden");
  }
  toggleWidgetNavbarVisibility() {
    let action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "show";
    this.$widgetTopBtnBox.classList[action === "show" ? "remove" : "add"]("qform-hidden");
    this.$widgetTopControlsBox.classList[action === "show" ? "remove" : "add"]("qform-hidden");
  }
  muteVideo() {
    let active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let node = this.$widgetTopBtnViewsBox.children;
    if (node) {
      for (let i = 0; i < node.length; i++) {
        if (node[i].classList.contains("active")) {
          let elVideo = node[i].querySelectorAll("video[id*='main-video']");
          elVideo = elVideo[elVideo.length - 1];
          elVideo.muted = active;
          this.player.muted(active);
          if (this.videoId === elVideo.id) {
            this.soundIsActive = active;
          }
          this.soundIsActive = active;
        }
      }
    }
  }
  loopCurrentVideo() {
    let isLoop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.player.loop(isLoop);
    this.player.currentTime(0);
  }
  playVideo(event) {
    event?.stopPropagation();

    //обработка случая перезагрузки видео при нажатии на него, а не на кнопку рестарта (видео закончилось)
    if (this.player.ended()) {
      this.reachYmTarget("qform_video_reload");
    }
    this.player.play();
    this.$widgetViewBoxControls.classList.remove("play");
    this.$widgetViewBoxControls.classList.remove("restart");
  }

  /**
   * Функция проигрывания ролика-превью.
   *
   * @description
   * В зависимости от значения `hoverPlay`, ролик-превью будет проигрываться:
   * - 0: Сразу после загрузки.
   * - 1: При наведении мыши.
   * - 2: Не проигрывать.
   *
   * @returns {void}
   */
  playPreview() {
    this.toggleOnHoverPlayIcon(false);
    if (this.elPreview) {
      switch (this.hoverPlay) {
        case 0:
          this.elPreview.play();
          break;
        case 1:
          this.elPreview.parentElement.addEventListener("mouseenter", () => {
            this.elPreview.play();
          });
          this.elPreview.parentElement.addEventListener("mouseleave", () => {
            this.elPreview.pause();
          });
          break;
        case 2:
          this.elPreview.pause();
          this.elPreview.currentTime = 0;
          break;
      }
      this.$widgetBox.classList.remove("play-icon");
    }
  }
  pauseVideo() {
    this.player.pause();
    this.$widgetViewBoxControls.classList.add("play");
    this.$widgetBox.classList.add("play-icon");
  }

  /**
   * функция остановки ролика-превью
   */
  stopPreview() {
    if (this.elPreview) {
      this.elPreview.pause();
      this.elPreview.currentTime = 0;
      this.elPreview.isEnded = false;
      this.toggleOnHoverPlayIcon();
    }
  }
  toggleOnHoverPlayIcon() {
    let show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.playOnHover && this.elVideoBox.classList.toggle("qform-OnHover-play", show);
  }
  async toggleFormVisibility() {
    let action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "show";
    this.hideMenu();
    this.$widgetFormWrapper?.classList[action === "show" ? "add" : "remove"]("qform-shown");
    this.isFormShown = action === "show";
  }
  closeFormOverlay() {
    this.toggleFormVisibility("hidden");
    if (!this.formWasSent) {
      this.showMenu();
    } else {
      this.toggleWidgetNavbarVisibility("show");
    }
  }
  onClickCloseFormOverlay() {
    this.closeFormOverlay();
    if (this.showFormInOverlay && this.player.paused()) {

      this.toggleWidgetNavbarVisibility("show");
      this.playVideo();
    }
  }
  onClickShowFormBtn() {
    this.toggleFormVisibility("show");
    if (this.showFormInOverlay) {
      this.toggleWidgetNavbarVisibility("hide");
      this.pauseVideo();
    }
  }
  async setWidgetForm() {
    if (!this.isFormAlreadyInit) {
      const $formRoot = document.createElement("div");
      $formRoot.dataset.formid = this.formData.form_id;
      this.$widgetFormBox.insertAdjacentElement("afterbegin", $formRoot);
      if (this.formData.form_type === 0) {
        //если в виджете простая форма
        this.emitterFormWidget.subscribe(`form_${this.formData.form_id}_init`, () => {
          //если к форме прикреплено видео
          if (this.formData.block_video_widget[0]) {
            const videoOptions = {
              mainVideo: this.formData.block_video_widget[0].mainVideo,
              preview: this.formData.block_video_widget[0].preview,
              resolution: this.formData.block_video_widget[0].resolution
            };
            this.setWidgetFormVideo(videoOptions);
          }
        });

        //слушаем событие успешной отправки формы
        this.emitterFormWidget.subscribe(`form_${this.formData.form_id}_send`, () => {
          const mainVideo = this.formData.video_widget_form_last.mainVideo;
          const preview = this.formData.video_widget_form_last.preview;
          const videoOptions = {
            mainVideo,
            preview,
            resolution: this.formData.video_widget_form_last.resolution
          };
          this.formWasSent = true;
          this.hideMenu();
          this.setWidgetFormVideo(videoOptions);
          this.startAfterSendFormTimeout();
        });
      } else {
        //если в виджете квиз
        this.formData.block_video_widget.forEach(block => {
          //слушаем события отсройки шагов с видео
          this.emitterFormWidget.subscribe(`block_${block.form_block_id}_build`, () => {
            //в случае, если форма в виджете вызывается по кнопке, при переключении шага снова показываем кнопку для ответа
            if (this.showFormInOverlay && this.isFormShown) {
              this.closeFormOverlay();
              this.toggleWidgetNavbarVisibility("show");
            }
            const mainVideo = block.mainVideo;
            const preview = block.preview;
            if (mainVideo && preview) {
              const videoOptions = {
                mainVideo: block.mainVideo,
                preview: block.preview,
                resolution: block.resolution
              };
              this.setWidgetFormVideo(videoOptions);
            }
          });
        });
        //слушаем событие отсройки шага с сообщением об успешной отправке
        this.emitterFormWidget.subscribe(`${this.formData.video_widget_form_last.form_id}_block_sent_build`, () => {
          const mainVideo = this.formData.video_widget_form_last.mainVideo;
          const preview = this.formData.video_widget_form_last.preview;
          this.formWasSent = true;
          this.hideMenu();
          if (mainVideo && preview) {
            const videoOptions = {
              mainVideo,
              preview,
              resolution: this.formData.video_widget_form_last.resolution
            };
            this.setWidgetFormVideo(videoOptions);
          }
          this.startAfterSendFormTimeout();
        });
      }
      try {
        await window.QFormOrganizer.generateOneForm($formRoot, this.formData.form_id, {
          noWidgets: true
        });
        this.isFormAlreadyInit = true;
      } catch (e) {

      }
    }

    //если форма показывается по своей кнопке
    if (this.showFormInOverlay) {
      this.$widgetFormWrapper.classList.add("qform-overlay");
      this.toggleCtaBtnVisibility("hide");
      this.$showFormButton = document.createElement("button");
      this.$showFormButton.type = "button";
      this.$showFormButton.classList.add("menu_btn");
      this.$showFormButton.id = `${this.widgetId}-${this.widgetIndex}_show-form-btn`;
      this.$showFormButton.innerText = this.settings.overlay_button;
      this.showMenu();
      this.$widgetMenuBox.insertAdjacentElement("beforeend", this.$showFormButton);
      this.$showFormButton.addEventListener("click", this.onClickShowFormBtn.bind(this));
      //если форма показывается сразу после нажатия CTA
    } else {
      this.toggleFormVisibility("show");
    }
  }
  setWidgetFormVideo(videoOptions) {
    this.mainVideoResolution = videoOptions.resolution;
    this.player.src([{
      src: videoOptions.mainVideo,
      type: "application/x-mpegURL"
    }]);
    //перезагрузка класса элемента виджета с кнопками "play" и "restart"
    this.$widgetViewBoxControls.className = "views-box_controls";
    this.player.play();
    this.elSourcePreview.src = videoOptions.preview;
    this.elPreview.load();
    if (!this.playOnHover) {
      this.elPreview.play();
    }
  }
  startAfterSendFormTimeout() {
    setTimeout(() => {
      this.closeFormOverlay();
      if (this.player.paused()) {
        this.playVideo();
      }
    }, 5000);
  }
  reachYmTarget(targetName) {
    if (this.settings.use_ym && this.settings.serial_id && window.ym) {
      ym(this.settings.ym_counter, "reachGoal", `${targetName}_${this.settings.serial_id}`);
    } else {
      if (this.settings.use_ym && this.settings.serial_id && this.settings.ym_counter && targetName) {
        try {
          window[`yaCounter${+this.settings.ym_counter}`]?.reachGoal(targetName);
        } catch (e) {
          throw new Error("Яндекс-метрика не подключена или подключена неверно");
        }
      }
    }
  }
  updateStatistics() {
    let oddData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!this.avoidStatistics) {
      const body = {
        uuid_stat: this.statId,
        site_id: this.siteId,
        was_opened: this.isExpandedOnceWidget ? 1 : 0,
        goal_cta: this.isCtaClickedOnce ? 1 : 0,
        build_time: this.buildTime,
        full_time: this.fullTime,
        is_mobile: this.device === "mobile" ? 1 : 0
      };
      if (oddData.fullView) {
        body.full_view = 1;
      }
      fetch(`https://${this.settings.options.server_host}${this.settings.options.stat_widgets_controller}`, {
        method: "POST",
        body: JSON.stringify(body)
      });
    }
  }
  setVideoViewInLocalStorage(status) {
    let viewsData = {};
    try {
      if (localStorage.getItem("qform_widgets_views")) {
        viewsData = JSON.parse(localStorage.getItem("qform_widgets_views"));
      }
    } catch (e) {

    } finally {
      viewsData[this.id] = status;
      localStorage.setItem("qform_widgets_views", JSON.stringify(viewsData));
    }
  }
  checkVideoFullViewed() {
    try {
      return JSON.parse(localStorage.getItem("qform_widgets_views"))[this.id];
    } catch (e) {

      return false;
    }
  }
  avoidStatistics() {
    return window.location.hostname === "dev-app.qform.io" || window.location.hostname === "app.qform.io";
  }
  scrollToBlock(selector) {
    const elemToReach = document.querySelector(selector);
    if (elemToReach) {
      window.scrollTo({
        top: elemToReach.getBoundingClientRect().top + window.pageYOffset - 30,
        behavior: "smooth"
      });
    } else {
      console.warn(`Невозможно выполнить скролл к блоку с селектором ${selector}, так как он отсутсвует на странице`);
    }
  }
  startWidget() {
    if (!this.isRunWidget) {
      this.startTimeRender = new Date().getTime();
      const box = this.getRoot();
      this.$root?.clear()?.append(box);
      this.$root.$el.classList.remove("qform__closed-widget");
      this.$root.$el.classList.add("running-widget");

      // const fonts = [
      //   {id: 'poiret_one', name: 'Poiret One', link: 'https://fonts.googleapis.com/css2?family=Poiret+One&display=swap'}
      // ]
      // const fontFromApi = 'poiret_one';
      // //примерение выбранного шрифта
      // const chosenFont = fonts.find(font => font.id == fontFromApi);
      // let fontLink = document.head.querySelector(`link#${chosenFont.id}`);

      // if (!fontLink) {
      //   fontLink = Utils.createLinkTag(chosenFont.link, chosenFont.id);
      //   document.head.append(fontLink);
      // }

      // this.$widgetBox.$el.style.fontFamily = `${chosenFont.name}, sans-serif`

      if (this.stylePreview === 1) {
        this.$root.$el.classList.add("integrated-widget");
        if (this.widgetOrientation === 2) {
          this.$root.$el.classList.add("square-widget");
        }
        if (this.widgetOrientation === 3) {
          this.$root.$el.classList.add("horizontal-widget");
        }
        if (this.widgetOrientation === 0) {
          this.$root.$el.classList.add("adaptive-widget");
        }
        //new
        if (this.isAdaptive) {
          this.$root.$el.classList.add("is-adaptive");
        }
      }
      if (this.playerType === 1) {
        this.$root.$el.classList.add("fullscreen-player");
      }
      if (this.playerType === 2) {
        this.$root.$el.classList.add("inside-player");
      }
      this.endTimeRender = new Date().getTime();
      this.buildTime = this.endTimeRender - this.startTimeRender;
      this.init();
      this.increaseInitCounter();

      //если виджет находится в теле страницы
      if (this.stylePreview === 1) {
        if (this.previewVideoUrl) {
          //если воспроизведение по наведению отключено
          if (!this.playOnHover) {
            if (!this.avoidPlay) {
              const callback = entries => {
                entries.forEach(entry => {
                  entry.isIntersecting ? this.playPreview() : this.stopPreview();
                });
              };
              const observer = new IntersectionObserver(callback.bind(this), {
                threshold: 0.5
              });
              observer.observe(this.$widgetBox);
              // this.playPreview()
            }
          }
        } else {
          if (!this.avoidPlay) {
            this.player.on("loadeddata", this.playVideo.bind(this));
          }
        }
      } else {
        if (!this.avoidPlay) {
          if (this.previewVideoUrl) {
            this.playPreview();
          } else {
            this.player.on("loadeddata", this.playVideo.bind(this));
          }
        }
      }
    }
    this.isRunWidget = true;
    if (this.showLogo) {
      this.startLabelProtectionInterval();
    }
  }
  resetWidget() {
    if (!this.isRunWidget) {
      this.emitterWidgets.emit("clearFreeWidgets", {});
      this.removeListener();
      this._setBtnCTA();
      this.expandedWidget = false;
      this.startWidget();
    }
  }
  startLabelProtectionInterval() {
    let interval = setInterval(() => {
      if (this.expandedWidget) {
        this.applyForceLabelStyles();
      }
      //останавливаем интервал при закрытии виджета
      if (!this.isRunWidget) {
        clearInterval(interval);
      }
    }, 5000);
    window.addEventListener("beforeunload", () => clearInterval(interval));
  }
  applyForceLabelStyles() {
    this.$widgetQformLabel.style = "opacity: 1 !important; display: inline !important; font-size: 10px !important;";
    this.$widgetQformLabelBox.style = "opacity: 1 !important; display: block !important; text-indent: 0 !important;";
  }
  increaseInitCounter() {
    let inits = JSON.parse(localStorage.getItem("qform_widgets_init_counter"));
    if (!inits) {
      inits = {};
    }
    if (inits[this.id]) {
      inits[this.id].count++;
    } else {
      inits[this.id] = {};
      inits[this.id].count = 1;
      inits[this.id].type = this.stylePreview;
    }
    localStorage.setItem("qform_widgets_init_counter", JSON.stringify(inits));
    return inits[this.id];
  }

  /**
   * Рендер виджета (по событию)
   */
  async render() {
    if (this.device !== "mobile" || this.device === "mobile" && this.settings.show_in_mobile) {
      await this.loadModule();
      if (this.loadBy === 1) {
        return this.startWidget();
      } else {
        const elements = this.settings.selector ? document.querySelectorAll(this.settings.selector) : [];
        switch (this.settings.event_by) {
          case "withdelay":
            const timeDelay = this.settings.load_by_time;
            setTimeout(this.resetWidget.bind(this), 1000 * timeDelay);
            break;
          case "click":
            elements.forEach(el => {
              el.addEventListener("click", this.resetWidget.bind(this));
            });
            break;
          case "mouseover":
            elements.forEach(el => {
              el.addEventListener("mouseover", this.resetWidget.bind(this));
            });
            break;
          case "onscroll":
            this.handleScroll(this.settings.selector);
            break;
          default:
            elements.forEach(el => {
              el.addEventListener(this.settings.event_by, this.resetWidget.bind(this));
            });
        }
      }
    }
  }

  /**
   * Отстройка виджета по скроллу до элемента
   * @param {string} selector - CSS-селектор элемента, за которым нужно наблюдать.
   * @returns {void}
   */
  handleScroll(selector) {
    if (!selector) return;
    const targetBlock = document.querySelector(selector);
    if (!targetBlock) return;
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.resetWidget();
          observer.disconnect();
        }
      });
    });
    observer.observe(targetBlock);
  }
}